(function () {
  if (window.empresasModalReady) return;
  window.empresasModalReady = true;

  var modal = null;
  var titleEl = null;
  var bodyEl = null;
  var closeEl = null;
  var lastFocus = null;

  function build() {
    modal = document.createElement('div');
    modal.className = 'emp emp-modal';
    modal.id = 'EmpresasModal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="emp-modal__overlay" data-emp-modal-close tabindex="-1"></div>' +
      '<div class="emp-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="EmpresasModalTitle">' +
      '<header class="emp-modal__head">' +
      '<h2 class="emp-modal__title" id="EmpresasModalTitle"></h2>' +
      '<button type="button" class="emp-modal__close" data-emp-modal-close aria-label="Cerrar">&times;</button>' +
      '</header>' +
      '<div class="emp-modal__body" data-emp-modal-body></div>' +
      '</div>';

    document.body.appendChild(modal);

    titleEl = modal.querySelector('.emp-modal__title');
    bodyEl = modal.querySelector('[data-emp-modal-body]');
    closeEl = modal.querySelector('.emp-modal__close');

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-emp-modal-close]')) close();
    });
  }

  function isOpen() {
    return !!modal && modal.classList.contains('is-open');
  }

  function focusables() {
    return Array.prototype.filter.call(
      modal.querySelectorAll('button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        return el.offsetParent !== null;
      }
    );
  }

  function open(trigger) {
    if (!modal) build();

    var wrap = trigger.closest('[data-emp-modal]') || trigger.closest('.emp-more') || trigger.parentElement;
    var template = wrap ? wrap.querySelector('template[data-emp-modal-content]') : null;

    titleEl.textContent = trigger.getAttribute('data-emp-modal-title') || '';
    bodyEl.innerHTML = '';
    if (template) bodyEl.appendChild(template.content.cloneNode(true));

    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
    bodyEl.scrollTop = 0;

    window.requestAnimationFrame(function () {
      if (closeEl) closeEl.focus();
    });
  }

  function close() {
    if (!isOpen()) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    var drawer = document.getElementById('EmpresasDrawer');
    if (!drawer || !drawer.classList.contains('is-open')) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-emp-modal-open]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
